var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-tel-input-vuetify',{attrs:{"preferred-countries":[
    'PT',
    'GB',
    'IE',
    'ES',
    'FR',
    'NL',
    'DE',
    'US',
    'DK',
    'SE',
    'BE',
    'CH'
  ],"label":_vm.label,"input-options":{ showDialCode: _vm.inputIsEmpty },"placeholder":"","error":_vm.isInvalid,"mode":'international',"autocomplete":"off","default-country":_vm.countryCode,"disabled-fetching-country":true,"rules":_vm.phoneRules,"loading":_vm.loading,"clearable":"","disabled":_vm.disabled,"rounded":_vm.rounded},on:{"country-changed":_vm.onCountryChange,"input":_vm.onChange},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }